// Native (Capacitor iOS/Android) sign-in helpers.
// Google: Emergent Auth runs inside the system browser (Google blocks embedded
// WebViews), lands on /api/auth/native-bridge, which reopens the app via
// balagha://auth/callback?session_id=… . Apple: native ASAuthorization sheet.
import { Browser } from "@capacitor/browser";
import { SignInWithApple } from "@capacitor-community/apple-sign-in";
import { api, API } from "@/lib/api";
import { setSessionToken } from "@/lib/session";

export const NATIVE_CALLBACK_PREFIX = "balagha://auth/callback";

let googlePending = false;
export const isGooglePending = () => googlePending;
export const clearGooglePending = () => {
  googlePending = false;
};

export async function startGoogleNative() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Native apps have no reachable window.location.origin, so the redirect is the
  // backend's public bridge page (derived from REACT_APP_BACKEND_URL via API).
  const redirect = `${API}/auth/native-bridge`;
  googlePending = true;
  await Browser.open({
    url: "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirect),
    presentationStyle: "fullscreen",
    toolbarColor: "#0c0a1a",
  });
}

export const closeBrowser = () => Browser.close().catch(() => {});

export const isAppleCancel = (e) =>
  /1001|cancel/i.test(String(e?.code || "") + " " + String(e?.message || e || ""));

export async function signInWithAppleNative() {
  const { response } = await SignInWithApple.authorize({
    scopes: "email name",
    state: crypto.randomUUID(),
  });
  if (!response?.identityToken) throw new Error("no_identity_token");
  const name = [response.givenName, response.familyName].filter(Boolean).join(" ") || null;
  return api.appleCallback(response.identityToken, name);
}

// Persist the session and only report success once /auth/me confirms a real account.
export async function finishLogin(res) {
  if (res?.session_token) await setSessionToken(res.session_token);
  let me = null;
  try {
    me = await api.me();
  } catch (_) {
    me = null;
  }
  if (!me || me.is_anonymous) {
    await setSessionToken(null);
    const err = new Error("session_not_established");
    err.code = "session";
    throw err;
  }
  localStorage.removeItem("balagha_uid");
  return me;
}
